
import { Options, Prop, Vue } from "vue-property-decorator";
import AdZone from "../AdZone.vue";

@Options({
  components: {
    AdZone,
  },
})
export default class Page extends Vue {
  @Prop({
    type: String,
    default: "div",
  })
  readonly is!: string;

  @Prop({
    type: Boolean,
    default: false,
  })
  readonly hasBanner!: boolean;
}
